import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPlasiyerTeklifDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerTeklifDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  UpdatePTeklifKuyruk: number;
  UpdatePTeklifKuyruk_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  GetPlasiyerYonetimTeklifTra: any[];
  GetPlasiyerYonetimTeklifTra_dummy: any[];
  HesaplaTeklifDetay: any[];
  HesaplaTeklifDetay_dummy: any[];
  UpdatePlasiyerTeklifMasMarka: number;
  UpdatePlasiyerTeklifMasMarka_dummy: number;
  GetPlasiyerTeklifFaturaDetaylari: any[];
  GetPlasiyerTeklifFaturaDetaylari_dummy: any[];
  GetCariYurticiBilgisiPlasiyer: any[];
  GetCariYurticiBilgisiPlasiyer_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  UpdatePTeklifFaturaBilgileri: number;
  UpdatePTeklifFaturaBilgileri_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp504507Visible: "visible" | "hidden";
  isComp766352Visible: "visible" | "hidden";
  isComp316718Visible: "visible" | "hidden";
  isComp685469Visible: "visible" | "hidden";
  isComp511736Visible: "visible" | "hidden";
  isComp250992Visible: "visible" | "hidden";
  isComp652258Visible: "visible" | "hidden";
  isComp459301Visible: "visible" | "hidden";
  isComp763897Enabled: "enabled" | "disabled";
}

export class PlasiyerTeklifDetay_ScreenBase extends React.PureComponent<
  IPlasiyerTeklifDetay_ScreenProps,
  any
> {
  plasiyerteklifdetay_997506_value_kuikaTableRef: React.RefObject<any>;
  plasiyerteklifdetay_809200_value_kuikaSelectBoxRef: React.RefObject<any>;
  plasiyerteklifdetay_28966_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 286595,
          PropertyName: "label",
          Value: "Add Discount",
          TagName: "Button3_label",
        },
        {
          Id: 504507,
          PropertyName: "label",
          Value: "Transfer to Netsis",
          TagName: "Button2_label",
        },
        {
          Id: 766352,
          PropertyName: "value",
          Value:
            "Before proceeding with the Netsis transfer, please check that all entered data is correct.",
          TagName: "Label83_value",
        },
        {
          Id: 218195,
          PropertyName: "value",
          Value: "Invoice Queued to be Transferred to Netsis",
          TagName: "Label84_value",
        },
        {
          Id: 216882,
          PropertyName: "value",
          Value: "Order Number",
          TagName: "Label42_value",
        },
        {
          Id: 686042,
          PropertyName: "value",
          Value: "Revision Number",
          TagName: "Label44_value",
        },
        {
          Id: 471490,
          PropertyName: "value",
          Value: "Current Code",
          TagName: "Label46_value",
        },
        {
          Id: 334223,
          PropertyName: "value",
          Value: "History",
          TagName: "Label48_value",
        },
        {
          Id: 187003,
          PropertyName: "value",
          Value: "Customer Request Number",
          TagName: "Label50_value",
        },
        {
          Id: 786345,
          PropertyName: "value",
          Value: "Sender",
          TagName: "Label51_value",
        },
        {
          Id: 881964,
          PropertyName: "title",
          Value: "Stock Code",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 71000,
          PropertyName: "title",
          Value: "Stock Name",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 78408,
          PropertyName: "title",
          Value: "Brand",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 221536,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 659395,
          PropertyName: "title",
          Value: "Discount Rates",
          TagName: "TableTemplateColumn13_title",
        },
        {
          Id: 794540,
          PropertyName: "title",
          Value: "Unit Price",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 340489,
          PropertyName: "title",
          Value: "Net Price",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 161484,
          PropertyName: "title",
          Value: "Net Amount",
          TagName: "TableTemplateColumn16_title",
        },
        {
          Id: 897550,
          PropertyName: "label",
          Value: "Save",
          TagName: "Button1_label",
        },
        {
          Id: 497239,
          PropertyName: "value",
          Value: "Payment Method",
          TagName: "Label75_value",
        },
        {
          Id: 417965,
          PropertyName: "value",
          Value: "Customer Request Number",
          TagName: "Label76_value",
        },
        {
          Id: 301973,
          PropertyName: "value",
          Value: "Packaging Type",
          TagName: "Label77_value",
        },
        {
          Id: 36097,
          PropertyName: "value",
          Value: "Export Type",
          TagName: "Label78_value",
        },
        {
          Id: 449483,
          PropertyName: "value",
          Value: "Package Description",
          TagName: "Label79_value",
        },
        {
          Id: 53923,
          PropertyName: "value",
          Value: "Project Code",
          TagName: "Label80_value",
        },
        {
          Id: 802014,
          PropertyName: "value",
          Value: "Special Note",
          TagName: "Label81_value",
        },
        {
          Id: 411670,
          PropertyName: "value",
          Value: "Delivery Day",
          TagName: "Label82_value",
        },
        {
          Id: 613305,
          PropertyName: "value",
          Value: "Total Amount",
          TagName: "Label24_value",
        },
        {
          Id: 947598,
          PropertyName: "value",
          Value: "Discount",
          TagName: "Label27_value",
        },
        {
          Id: 6681,
          PropertyName: "value",
          Value: "Net Amount",
          TagName: "Label30_value",
        },
        {
          Id: 827790,
          PropertyName: "value",
          Value: "Kdv",
          TagName: "Label33_value",
        },
        {
          Id: 482792,
          PropertyName: "value",
          Value: "General Discount 1",
          TagName: "Label37_value",
        },
        {
          Id: 227071,
          PropertyName: "value",
          Value: "General Discount 2",
          TagName: "Label36_value",
        },
        {
          Id: 795706,
          PropertyName: "value",
          Value: "General Discount 3",
          TagName: "Label69_value",
        },
        {
          Id: 877549,
          PropertyName: "value",
          Value: "Grand Total",
          TagName: "Label72_value",
        },
        {
          Id: 69038629,
          PropertyName: "15e795f4-e6c3-b533-b0f7-8a9343d7da05_notify",
          Value: "Transaction Successfully Completed and Queued",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 71856048,
          PropertyName: "39be20b8-75f7-6f7e-20b0-7e6585cac77d_notify",
          Value: "Save Successful",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "203cf959-6f8e-4925-8adc-0c15dea06538",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 504507, PropertyName: "label", Value: "Netsise Aktar" },
        {
          Id: 766352,
          PropertyName: "value",
          Value:
            "Netsis aktarımına geçmeden önce, lütfen girilen tüm verilerin doğruluğunu kontrol edin.",
        },
        {
          Id: 218195,
          PropertyName: "value",
          Value: "Fatura Netsise Aktarılmak İçin Kuyruğa Alındı",
        },
        { Id: 544724, PropertyName: "value", Value: "B2B Teklif Detayları" },
        { Id: 216882, PropertyName: "value", Value: "Sipariş Numarası" },
        { Id: 686042, PropertyName: "value", Value: "Revize Numarası" },
        { Id: 471490, PropertyName: "value", Value: "Cari Kod" },
        { Id: 334223, PropertyName: "value", Value: "Tarih" },
        { Id: 187003, PropertyName: "value", Value: "Müşteri Talep No" },
        { Id: 786345, PropertyName: "value", Value: "Gönderen" },
        { Id: 881964, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 419178, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 71000, PropertyName: "title", Value: "Stok Adı" },
        { Id: 282856, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 78408, PropertyName: "title", Value: "Marka" },
        {
          Id: 626485,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 221536, PropertyName: "title", Value: "Miktar" },
        { Id: 204196, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 659395, PropertyName: "title", Value: "İskonto Oranları" },
        {
          Id: 323159,
          PropertyName: "value",
          Value: "[datafield:iskontoorani]",
        },
        { Id: 794540, PropertyName: "title", Value: "Birim Fiyat" },
        { Id: 12822, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 340489, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 434995, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 161484, PropertyName: "title", Value: "Net Tutar" },
        { Id: 954839, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 286595, PropertyName: "label", Value: "İskonto Ekle" },
        { Id: 435357, PropertyName: "value", Value: "Fatura Bilgileri" },
        { Id: 497239, PropertyName: "value", Value: "Ödeme Şekli" },
        { Id: 417965, PropertyName: "value", Value: "Müşteri Talep No" },
        { Id: 301973, PropertyName: "value", Value: "Paketleme Şekli" },
        { Id: 36097, PropertyName: "value", Value: "İhracat Tipi" },
        { Id: 449483, PropertyName: "value", Value: "Paket Açıklama" },
        { Id: 53923, PropertyName: "value", Value: "Proje Kodu" },
        { Id: 802014, PropertyName: "value", Value: "Özel Not" },
        { Id: 411670, PropertyName: "value", Value: "Teslim Günü" },
        { Id: 897550, PropertyName: "label", Value: "Kaydet" },
        { Id: 412073, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 613305, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 947598, PropertyName: "value", Value: "İskonto" },
        { Id: 6681, PropertyName: "value", Value: "Net Tutar" },
        { Id: 827790, PropertyName: "value", Value: "Kdv" },
        { Id: 482792, PropertyName: "value", Value: "Genel Iskonto 1" },
        { Id: 227071, PropertyName: "value", Value: "Genel Iskonto 2" },
        { Id: 795706, PropertyName: "value", Value: "Genel Iskonto 3" },
        { Id: 877549, PropertyName: "value", Value: "Genel Toplam" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.plasiyerteklifdetay_997506_value_kuikaTableRef = React.createRef();
    this.plasiyerteklifdetay_752048_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifdetay_296409_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifdetay_763897_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifdetay_809200_value_kuikaSelectBoxRef = React.createRef();
    this.plasiyerteklifdetay_307254_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifdetay_28966_value_kuikaSelectBoxRef = React.createRef();
    this.plasiyerteklifdetay_222512_value_kuikaTextInputRef = React.createRef();
    this.plasiyerteklifdetay_482513_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      TriggerEvent: "",
      UpdatePTeklifKuyruk: 0,
      Notify: false,
      GoBack: "",
      GetPlasiyerYonetimTeklifTra: [],
      HesaplaTeklifDetay: [],
      UpdatePlasiyerTeklifMasMarka: 0,
      GetPlasiyerTeklifFaturaDetaylari: [],
      GetCariYurticiBilgisiPlasiyer: [],
      NAVIGATE: "",
      IfThenElse: false,
      dataSource_809200: [
        { key: "1", text: "FOB" },
        { key: "2", text: "CIF" },
        { text: "CF", key: "3" },
        { text: "FOT", key: "4" },
        { text: "IHRAÇ KAYITLI", key: "5" },
        { text: "DAF", key: "6" },
        { text: "EXW", key: "7" },
        { text: "iHR KUR FARKI", key: "8" },
        { text: "CIP", key: "9" },
        { text: "CPT", key: "10" },
        { text: "DAT", key: "11" },
        { text: "DAP", key: "12" },
        { text: "DDP", key: "13" },
        { text: "DES", key: "14" },
        { text: "DEQ", key: "15" },
        { text: "DDU", key: "16" },
        { text: "FCA", key: "17" },
        { text: "FAS", key: "18" },
        { text: "CFR", key: "19" },
      ],
      dataSource_28966: [
        { key: "A", text: "A" },
        { text: "R", key: "R" },
      ],
      isComp504507Visible: "hidden",
      isComp766352Visible: "hidden",
      isComp316718Visible: "hidden",
      isComp685469Visible: "hidden",
      isComp511736Visible: "hidden",
      isComp250992Visible: "hidden",
      isComp652258Visible: "hidden",
      isComp459301Visible: "hidden",
      isComp763897Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("plasiyerteklifdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PlasiyerTeklifDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("plasiyerteklifdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("plasiyerteklifdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerTeklifDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      plasiyerteklifdetay_752048_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.odemeTipi ??
        undefined,
      plasiyerteklifdetay_296409_value:
        this.props.screenInputs.TalepNo ?? this.props.screenInputs.talepno,
      plasiyerteklifdetay_763897_value:
        this.state.GetPlasiyerYonetimTeklifTra?.at?.(0)?.musteriMarka ??
        undefined,
      plasiyerteklifdetay_809200_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.ihracatTipi ??
        undefined,
      plasiyerteklifdetay_307254_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.paketAciklama ??
        undefined,
      plasiyerteklifdetay_28966_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.projeKodu ??
        undefined,
      plasiyerteklifdetay_222512_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.ozelNot ??
        undefined,
      plasiyerteklifdetay_482513_value:
        this.state.GetPlasiyerTeklifFaturaDetaylari?.at?.(0)?.teslimGunu ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerTeklifDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      CariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      marka_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetPlasiyerYonetimTeklifTra !== undefined
            ? stateVars.GetPlasiyerYonetimTeklifTra?.length > 0
              ? stateVars.GetPlasiyerYonetimTeklifTra[0].musteriMarka
              : null
            : this.state.GetPlasiyerYonetimTeklifTra?.length > 0
            ? this.state.GetPlasiyerYonetimTeklifTra[0].musteriMarka
            : null
        ),
        "string"
      ),
      TeklifNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      TeklifNumarasi_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
      FirmaKodu_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifDetay/PlasiyerTeklifDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPlasiyerYonetimTeklifTra =
      result?.data.getPlasiyerYonetimTeklifTra;

    formVars.plasiyerteklifdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerYonetimTeklifTra !== undefined
        ? stateVars.GetPlasiyerYonetimTeklifTra?.length > 0
          ? stateVars.GetPlasiyerYonetimTeklifTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerYonetimTeklifTra?.length > 0
        ? this.state.GetPlasiyerYonetimTeklifTra[0].musteriMarka
        : null
    );
    stateVars.HesaplaTeklifDetay = result?.data.hesaplaTeklifDetay;
    formVars.plasiyerteklifdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );
    formVars.plasiyerteklifdetay_388552_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );
    formVars.plasiyerteklifdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );
    formVars.plasiyerteklifdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );
    formVars.plasiyerteklifdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );
    formVars.plasiyerteklifdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );
    formVars.plasiyerteklifdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );
    formVars.plasiyerteklifdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );
    stateVars.isComp511736Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp250992Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp652258Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp459301Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.UpdatePlasiyerTeklifMasMarka =
      result?.data.updatePlasiyerTeklifMasMarka;
    stateVars.GetPlasiyerTeklifFaturaDetaylari =
      result?.data.getPlasiyerTeklifFaturaDetaylari;
    formVars.plasiyerteklifdetay_752048_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].odemeTipi
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].odemeTipi
        : null
    );
    formVars.plasiyerteklifdetay_809200_value =
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].ihracatTipi
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].ihracatTipi
        : null;
    formVars.plasiyerteklifdetay_307254_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].paketAciklama
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].paketAciklama
        : null
    );
    formVars.plasiyerteklifdetay_28966_value =
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].projeKodu
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].projeKodu
        : null;
    formVars.plasiyerteklifdetay_222512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].ozelNot
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].ozelNot
        : null
    );
    formVars.plasiyerteklifdetay_482513_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].teslimGunu
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].teslimGunu
        : null
    );
    stateVars.isComp504507Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp766352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp316718Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCariYurticiBilgisiPlasiyer =
      result?.data.getCariYurticiBilgisiPlasiyer;
    stateVars.isComp685469Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerTeklifDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp504507Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp766352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp316718Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_997506 =
      stateVars.GetPlasiyerYonetimTeklifTra ??
      this.state.GetPlasiyerYonetimTeklifTra;
    formVars.plasiyerteklifdetay_752048_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].odemeTipi
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].odemeTipi
        : null
    );

    formVars.plasiyerteklifdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerYonetimTeklifTra !== undefined
        ? stateVars.GetPlasiyerYonetimTeklifTra?.length > 0
          ? stateVars.GetPlasiyerYonetimTeklifTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerYonetimTeklifTra?.length > 0
        ? this.state.GetPlasiyerYonetimTeklifTra[0].musteriMarka
        : null
    );

    stateVars.isComp685469Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifdetay_809200_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].ihracatTipi
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].ihracatTipi
        : null
    );

    formVars.plasiyerteklifdetay_307254_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].paketAciklama
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].paketAciklama
        : null
    );

    formVars.plasiyerteklifdetay_28966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].projeKodu
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].projeKodu
        : null
    );

    formVars.plasiyerteklifdetay_222512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].ozelNot
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].ozelNot
        : null
    );

    formVars.plasiyerteklifdetay_482513_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerTeklifFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerTeklifFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerTeklifFaturaDetaylari[0].teslimGunu
          : null
        : this.state.GetPlasiyerTeklifFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerTeklifFaturaDetaylari[0].teslimGunu
        : null
    );

    formVars.plasiyerteklifdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamTutar
        : null
    );

    formVars.plasiyerteklifdetay_388552_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].toplamIskontoTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].toplamIskontoTutar
        : null
    );

    formVars.plasiyerteklifdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].netTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].netTutar
        : null
    );

    stateVars.isComp511736Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].kdvTutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].kdvTutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].kdvTutar
        : null
    );

    stateVars.isComp250992Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk1Tutar
        : null
    );

    stateVars.isComp652258Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk2Tutar
        : null
    );

    stateVars.isComp459301Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaTeklifDetay !== undefined
            ? stateVars.HesaplaTeklifDetay?.length > 0
              ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaTeklifDetay?.length > 0
            ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyerteklifdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelIsk3Tutar
        : null
    );

    formVars.plasiyerteklifdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaTeklifDetay !== undefined
        ? stateVars.HesaplaTeklifDetay?.length > 0
          ? stateVars.HesaplaTeklifDetay[0].genelToplam
          : null
        : this.state.HesaplaTeklifDetay?.length > 0
        ? this.state.HesaplaTeklifDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_504507_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.PlasiyerTeklifDetayComponent_897550_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifDetayComponent_504507_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PlasiyerTeklifDetayComponent_504507_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TeklifNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifDetay/PlasiyerTeklifDetayComponent_504507_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePTeklifKuyruk = result?.data.updatePTeklifKuyruk;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerTeklifDetayComponent_504507_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerTeklifDetayComponent_504507_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "15e795f4_e6c3_b533_b0f7_8a9343d7da05_notify",
        this.defaultML,
        "İşlem Başarıyla Gerçekleşti ve Kuyruğa Alındı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_61380_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_286595_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerTeklifIskontoEkle",
      "TeklifNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerTeklifDetay",
      "PlasiyerTeklifIskontoEkle",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "209580",
      null,
      null,
      "true",
      "500px",
      "55vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_897550_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifdetay_752048_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyerteklifdetay_752048_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifdetay_28966_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyerteklifdetay_28966_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PaketlemeSekli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_763897_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IhracatTipi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      PaketAciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_307254_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OzelNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_222512_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OdemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_752048_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TalepNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_296409_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TeslimGunu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_482513_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_28966_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifDetay/PlasiyerTeklifDetayComponent_897550_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePTeklifFaturaBilgileri =
      result?.data.updatePTeklifFaturaBilgileri;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_897550_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid:
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_809200_value",
            "value",
            "",
            "key",
            ""
          ),
          null
        ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
              ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
                ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
                : null
              : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("False", "string")
        ),
      message: "Zorunlu Alan !",
      formName: "plasiyerteklifdetay_809200_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifdetay_752048_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyerteklifdetay_752048_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyerteklifdetay_28966_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyerteklifdetay_28966_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PaketlemeSekli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_763897_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IhracatTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_809200_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      PaketAciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_307254_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OzelNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_222512_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OdemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_752048_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TalepNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_296409_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TeslimGunu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_482513_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyerteklifdetay_28966_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerTeklifDetay/PlasiyerTeklifDetayComponent_897550_onClick_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePTeklifFaturaBilgileri =
      result?.data.updatePTeklifFaturaBilgileri;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  PlasiyerTeklifDetayComponent_897550_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.PlasiyerTeklifDetayComponent_897550_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.PlasiyerTeklifDetayComponent_897550_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "39be20b8_75f7_6f7e_20b0_7e6585cac77d_notify",
        this.defaultML,
        "Kaydetme İşlemi Başarılı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [209580] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerTeklifDetayPageInit();
    }
  }
}
